import { render } from "./otpl.vue?vue&type=template&id=20c829a5"
import script from "./otpl.vue?vue&type=script&lang=js"
export * from "./otpl.vue?vue&type=script&lang=js"

import "./otpl.vue?vue&type=style&index=0&id=20c829a5&lang=css"

import exportComponent from "C:\\Github\\dev-mynet\\Products\\Hub\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__